<template>
 <span class="badge badge-pill px-2 py-1" v-bind:class="getStatusClass">
   <span  class="fas fa-circle small"></span> {{getStatus()}}
 </span>
</template>
<script>
  const PENDING = 1;
  const GENERATED = 2;
  const CONFIRMATED = 3;
  const RESCHEDULED = 4;
  const CANCELLED = 5;

  export default {
    props: ['status'],
    methods: {
      getStatus() {
        const status = Number(this.status);
        switch (status) {
          case PENDING:
            return "Pendiente";
          case GENERATED:
            return "Generado";
          case CONFIRMATED:
            return "Confirmado";
          case RESCHEDULED:
            return "Re-Agendado";
          case CANCELLED:
            return "Cancelado";
          default:
            return ""
        }
      }
    },
    computed: {
      getStatusClass() {
        const status = Number(this.status);
        switch (status) {
          case PENDING:
            return 'badge-danger';
          case GENERATED:
            return 'badge-info';
          case CONFIRMATED:
            return 'badge-success';
          case RESCHEDULED:
            return 'badge-warning';
          case CANCELLED:
            return 'badge-danger';
          default:
            return ""

        }
      }
    }
  }
</script>
